// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-wrapper{z-index:9000;position:fixed;width:100vw;background-color:transparent;height:50px;min-height:50px;display:flex;justify-content:space-between;align-items:center;padding:0 10px;margin:5px 0}.header-logo{height:50px}\n", ""]);
// Exports
module.exports = exports;
